import CryptoJS from 'crypto-js';

const dnKey = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];

const Texto = {
  Obfuscar: (texto: string) => {
    try {
      // Converter chave para WordArray - mesma forma que aesjs
      const key = CryptoJS.lib.WordArray.create(new Uint8Array(dnKey));
      
      // CTR mode - o aesjs inicia o counter em [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1]
      // Vamos tentar com IV = counter inicial
      const iv = CryptoJS.lib.WordArray.create(new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1]));
      
      const encrypted = CryptoJS.AES.encrypt(texto, key, {
        mode: CryptoJS.mode.CTR,
        iv: iv,
        padding: CryptoJS.pad.NoPadding
      });
      
      return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
    } catch (e) {
      return null;
    }
  },
  
  Desobfuscar: (textoHex: string) => {
    if(JSON.stringify(textoHex) === '{}'){
      return null;
    }
    try { 
      // Converter chave para WordArray
      const key = CryptoJS.lib.WordArray.create(new Uint8Array(dnKey));
      
      // Tentar diferentes valores de counter/IV
      const counterValues = [
        new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1]), // counter inicial do aesjs
        new Uint8Array(16), // todos zeros
        new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]) // explicitamente zeros
      ];
      
      for (let i = 0; i < counterValues.length; i++) {
        try {
          const iv = CryptoJS.lib.WordArray.create(counterValues[i]);
          const ciphertext = CryptoJS.enc.Hex.parse(textoHex);
          
          const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: ciphertext } as any,
            key,
            {
              mode: CryptoJS.mode.CTR,
              iv: iv,
              padding: CryptoJS.pad.NoPadding
            }
          );
          
          const result = decrypted.toString(CryptoJS.enc.Utf8);
          
          // Verificar se o resultado faz sentido (não está vazio e tem caracteres válidos)
          if (result && result.length > 0) {
            return result;
          }
        } catch (e) {
        }
      }
      
      // Se todas as tentativas falharam, tentar abordagem alternativa
      return Texto.DesobfuscarAlternativo(textoHex);
      
    } catch (e) {
      return null;
    }
  },
  
  // Método alternativo que simula mais de perto o comportamento do aesjs
  DesobfuscarAlternativo: (textoHex: string) => {
    try {
      // Tentar com chave como string hexadecimal
      const keyHex = dnKey.map(n => n.toString(16).padStart(2, '0')).join('');
      const key = CryptoJS.enc.Hex.parse(keyHex);
      const ciphertext = CryptoJS.enc.Hex.parse(textoHex);
      
      // Tentar diferentes configurações
      const configs = [
        { mode: CryptoJS.mode.CTR, iv: CryptoJS.lib.WordArray.create(new Uint8Array(16)) },
        { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.NoPadding },
        { mode: CryptoJS.mode.CBC, iv: CryptoJS.lib.WordArray.create(new Uint8Array(16)), padding: CryptoJS.pad.NoPadding }
      ];
      
      for (let i = 0; i < configs.length; i++) {
        try {
          const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: ciphertext } as any,
            key,
            configs[i]
          );
          
          const result = decrypted.toString(CryptoJS.enc.Utf8);
          
          if (result && result.length > 0 && !result.includes('\u0000')) {
            return result;
          }
        } catch (e) {
        }
      }
      
      return null;
    } catch (e) {
      return null;
    }
  }
};

export default Texto;